var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.support}},[_c('span',{staticClass:"mr-25 align-middle"},[_vm._v("Go To Help Guides")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }